var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1203 8.10666L11.3337 16.8933L6.54699 12.12L4.66699 14L11.3337 20.6667L22.0003 9.99999L20.1203 8.10666ZM14.0003 0.666656C6.64033 0.666656 0.666992 6.63999 0.666992 14C0.666992 21.36 6.64033 27.3333 14.0003 27.3333C21.3603 27.3333 27.3337 21.36 27.3337 14C27.3337 6.63999 21.3603 0.666656 14.0003 0.666656ZM14.0003 24.6667C8.10699 24.6667 3.33366 19.8933 3.33366 14C3.33366 8.10666 8.10699 3.33332 14.0003 3.33332C19.8937 3.33332 24.667 8.10666 24.667 14C24.667 19.8933 19.8937 24.6667 14.0003 24.6667Z",
    fill: "#75B843"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/IconSuccess.f26ab899.svg";
export { ForwardRef as ReactComponent };